import { injectTestEnv } from './env';

export async function withOptionalDevConfig() {
  if (import.meta.env.DEV) {
    if (import.meta.env.VITE_DEV_WITH_SYSTEEMTEST === 'true') {
      console.log('Dev with Keycloak auth enabled');
      injectTestEnv({
        apiUrlNS: 'http://backend:8080/bam-client', // NOSONAR
        keycloakUrlNS: 'http://keycloak:8080', // NOSONAR
        keycloakRealmNS: 'BAMBIJS',
        keycloakClientNS: 'bam-client-frontend',
        featureBakkenteller: true,
        featureAgenda: true,
        featureSchraplijsten: true,
        authProvider: 'oidc',
        featureLmm: true,
        featureWts: true,
        branchName: 'lokaal',
        imageBuildNumber: 'systeemtest',
      });
    } else if (import.meta.env.MODE === 'proxy-acceptatie') {
      console.log('Dev with proxy to backend acceptatie');
      injectTestEnv({
        apiUrlNS: 'acceptatie',
        authRedirectUri: 'http://localhost:5173/acceptatie/auth/callback',
        featureBakkenteller: true,
        featureAgenda: true,
        featureSchraplijsten: true,
        authProvider: 'bff-cookie',
        featureLmm: true,
        featureWts: true,
        branchName: 'lokaal',
        imageBuildNumber: 'proxy-acceptatie',
      });
    } else if (import.meta.env.MODE === 'proxy-test') {
      console.log('Dev with proxy to backend test');
      injectTestEnv({
        apiUrlNS: 'test',
        authRedirectUri: 'http://localhost:5173/test/auth/callback',
        featureBakkenteller: true,
        featureAgenda: true,
        featureSchraplijsten: true,
        authProvider: 'bff-cookie',
        featureLmm: true,
        branchName: 'lokaal',
        imageBuildNumber: 'proxy-test',
        featureWts: true,
      });
    } else {
      injectTestEnv({
        apiUrlNS: '',
        featureBakkenteller: true,
        featureAgenda: true,
        featureSchraplijsten: true,
        authProvider: 'oidc',
        featureLmm: true,
        featureWts: true,
        branchName: 'lokaal',
        imageBuildNumber: 'mock',
      });
      const { worker } = await import('../mocks/browser');
      return worker.start();
    }
  }
}

export function isSecurityEnabled() {
  const isDevWithSysteemtestEnabled = import.meta.env.DEV && import.meta.env.VITE_DEV_WITH_SYSTEEMTEST === 'true';
  const securityEnabled = true;
  if (import.meta.env.DEV && !import.meta.env.MODE.includes('proxy')) {
    return isDevWithSysteemtestEnabled;
  }
  return securityEnabled;
}

export const isSecurityDisabled = () => !isSecurityEnabled();
